import styled from 'react-emotion'
import { space, color, borderRadius, border } from '../../style'
import { StyledFormElement as FormElement } from './FormElement'

export const DetailsBox = styled('div')(({ outline }) => ({
  label: 'DetailsBox',
  margin: space.default,
  position: 'relative',
  '&:before': outline && {
    content: '""',
    border: `1px solid ${color.black}`,
    borderRadius,
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 1,
    pointerEvents: 'none'
  },

  [FormElement]: {
    flex: 1, // full width 
    width: '100%', // full width - needed for input elements
    '&:not(:last-child)': {
      borderBottom: 'none',
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0
    },
    '&:not(:first-child)': {
      borderTopRightRadius: 0,
      borderTopLeftRadius: 0
    }
  }
}))

DetailsBox.Row = styled(FormElement)(() => ({
  label: 'DetailsBoxRow',
  display: 'flex',
  // flex-wrap: wrap;  // alows flex-basis:100% items to sit above each other
  '&:not(:last-child)': {
    borderBottom: border
  },
  [FormElement]: {
    border: 'none',
    '&:not(:last-child)': {
      borderRadius: 0,
      borderRight: border
    },
    padding: 0,
    flex: 1,
    height: '100%', // TODO fix form-element heights
  }
}))

export const StyledDetailsBox = DetailsBox
export default DetailsBox
